import { PageHero } from '@/components/ui/PageHero'
import { kandakeOutdoors } from '@/assets/siteMedia'

export const ServicesHero = () => (
  <PageHero
    image={kandakeOutdoors}
    imageAlt="Kandake selecting fresh medicinal plants in a garden"
    highlights={['Consultations', 'Bio-Scan assessments', 'Courses & workshops', 'Herbal products']}
    title="Care that goes beyond"
    accent="the symptom."
    description={
      <p>
        Every service at Instrumental Health treats the whole person, not just the condition. Rooted
        in traditional wisdom, supported by clinical science.
      </p>
    }
  />
)
